import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Speciality } from '@barges/react';
import '@barges/scss/lib/speciality.css';
import '@barges/scss/lib/title.css';
import withPGTranslation from '../../../../config/withPGTranslation';
import classes from './classes.module.scss';
import AppLink from '../../../routes/app_link';
import { specialitiesClickSource } from '../../../../config/const';
import { isPG } from '../../../../../common/config/utils';

const renderSpecialitiesContent = (specialities, loading, specialitiesContent) => (
  !(specialities || []).length && !loading ? null : specialitiesContent()
);

function AdvisorSpecialities({
  specialities,
  advisorId,
  t,
  loading = false
}) {
  const speciality = (spec) => {
    const  {
      iconUrl, name, slug, params, iconName
    } = spec;
    return (
      <AppLink
        to={ {
          pathname: slug,
          state: {
            needRefresh: true,
            trackCategoryEvent: true,
            clickSource: specialitiesClickSource.advisorProfile,
            advisorId,
            params
          }
        } }
        key={ `speciality_${ name }` }
      >
        <Speciality
          type="advisor-profile"
          speciality={ { iconName: isPG() ? iconName : null, name, iconUrl } }
          suppressHydrationWarning
        />
      </AppLink>
    );
  };

  const specialitiesContent = () => (
    <div className={ classes.descriptionHolder } suppressHydrationWarning>
      {t('advisor_profile.specialities_title')}
      <div className={ classes.specialitiesContainer } suppressHydrationWarning>
        { loading
          ? (
            <Skeleton
              count={ 3 }
              containerClassName={ classes.specialitySkeletonContainer }
              className={ classes.specialitySkeleton }
            />
          ) : specialities.map((s) => speciality(s))}
      </div>
    </div>
  );

  return renderSpecialitiesContent(specialities, loading, specialitiesContent);
}

export default withPGTranslation(AdvisorSpecialities);
